<template>
  <div class="page-research">

    <div class="g-banner">

      <cmpBanner bannerType="1"></cmpBanner>
      <div class="g-tab-box">
        <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
      </div>
    </div>

    <div class="g-content-wrap">
      <div class="norem-left">
        <h1>导览</h1>
        <ul>
          <li v-for="(item, index) in menuList" :key="index">

            <div class="item" style="padding: 0;" v-if="item.children && item.children.length > 0">
              <div class="flex-box">
                <span class="item-name " @click="handleFold(item)"> {{item.name}}</span>
                <img
                  :src="item.fold ? require('../../assets/images/icon_up@2x.png'): require('../../assets/images/icon_down@2x.png')"
                  alt="">
              </div>

              <template v-if="item.fold">
                <div v-for="(it, dx) in item.children" @click="changeSubCom(item,it)" :key="dx">
                  <span class="item-name" :class="{'active':it.id === activeSubVal}"
                    style="padding-left: 30px;">{{ it.name }}</span>
                </div>
              </template>
            </div>

            <div class="item no-child" v-else :class="{'active': item.id === activeVal}" @click="changeCom(item)">
              {{ item.name }}
            </div>
          </li>
        </ul>
      </div>

      <div class="norem-right">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import openTime from './open-time.vue'
import ticket from './ticket.vue'
import traffic from './traffic.vue'
import notice from './notice.vue'
import guide from './guide.vue'
import explain from './explain.vue'
import voice from './voice.vue'
import dinningBar from './dining-bar.vue'
import cmpTab from '@cmp/tab'

export default {
  components: {
    dinningBar,
    openTime,
    traffic,
    explain,
    cmpTab,
    notice,
    ticket,
    guide,
    voice
  },
  watch: {
    $route(to, from) {
      this.activeVal = to.query.type || '1'
      if (this.activeVal == 6) {
        this.menuList[5].fold = true
        this.activeSubVal = to.query.subType  
      }
      if (this.$route.query.isWifi == '1') {
        this.$nextTick(function () {
          window.scrollTo(0, document.documentElement.scrollHeight)
        });
      }
    }
  },
  data() {
    return {
      chooseCom: 'openTime',
      activeVal: this.$route.query.type || '1',
      activeSubVal: '',
      tabList: [
        {
          name: '开放时间',
          val: '1'
        },
        {
          name: '入馆须知',
          val: '2'
        },
        {
          name: '交通路线',
          val: '3'
        },
        {
          name: '参观须知',
          val: '4'
        },
        {
          name: '展区导引',
          val: '5'
        },
        {
          name: '馆内服务',
          val: '6'
        }
      ],
      menuList: [{ id: '1', name: '开放时间', path: '/museum/open-time?type=1' },
      { id: '2', name: '入馆须知', path: '/museum/ticket?type=2' },
      { id: '3', name: '交通路线', path: '/museum/traffic?type=3' },
      { id: '4', name: '参观须知', path: '/museum/notice?type=4' },
      { id: '5', name: '展区导引', path: '/museum/guide?type=5' },
      {
        id: '6', name: '馆内服务', fold: false, children: [
          { id: '61', name: '讲解服务', path: '/museum/explain?type=6&subType=61' },
          { id: '62', name: '语音导览服务', path: '/museum/voice?type=6&subType=62' },
          { id: '63', name: '餐吧及其他设施', path: '/museum/dinning-bar?type=6&subType=63' }
        ]
      }],
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 9,
      },
      total: 0,
    }
  },

  methods: {
    eventTabClick(val) {
      this.activeVal = val
      this.menuList.map(item => {
        if (item.id == val) {
          if (item.path) {
            this.$router.push(item.path)
          } else {
            if (item.children && item.children.length > 0) {
              item.fold = true
              this.activeSubVal = item.children[0].id
              this.$router.push(item.children[0].path)
            }
          }
        }
      })
    },

    changeCom(obj) {
      this.activeVal = obj.id
      this.$router.push(obj.path)
    },

    changeSubCom(parent, child) {
      this.activeVal = parent.id
      this.activeSubVal = child.id
      this.$router.push(child.path)

    },

    handleFold(obj) {
      obj.fold = !obj.fold
    },
    //  表格分页
  },
  created() {
    this.activeVal = this.$route.query.type || '1'
    if (this.activeVal == 6) {
      this.menuList[5].fold = true
      this.activeSubVal = this.menuList[5].children[0].id
    }
    if (this.$route.query.isWifi == '1') {
      this.$nextTick(function () {
        window.scrollTo(0, document.documentElement.scrollHeight)
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.g-content-wrap {
  width: 1600px;
  margin: 120px auto 0;
  display: flex;
  margin-bottom: 20px;
  .norem-left {
    flex-basis: 234px;
    h1 {
      padding: 30px 20px;
      background: #ae8148;
      color: #fff;
      font-size: 28px;
    }
    ul {
      border: 1px solid rgba(215, 215, 215, 1);
      li {
        font-size: 20px;
        color: #000000;
        font-weight: 400;
        cursor: pointer;
        border-bottom: 1px solid rgba($color: #312f2e, $alpha: 0.1);
        display: flex;
        align-items: center;
        padding: 0 10px;
        .item {
          width: 100%;
          padding: 16px 0;
          &.no-child {
            &:hover {
              color: #af8653;
            }
          }
          .flex-box {
            align-items: center;
            justify-content: space-between;
          }
          img {
            width: 18px;
            height: 9px;
          }

          span {
            box-sizing: border-box;
            display: inline-block;
            padding: 16px 0;
            width: 100%;
            &.item-name {
              &:hover {
                color: #af8653;
              }
            }

            &.active {
              color: #af8653;
              &::before {
                display: inline-block;
                margin-right: 8px;
                content: '';
                position: relative;
                top: 3px;
                width: 2px;
                height: 20px;
                background: #af8653;
              }
            }
          }
          &.active {
            color: #af8653;
            &::before {
              display: inline-block;
              margin-right: 8px;
              content: '';
              position: relative;
              top: 3px;
              width: 2px;
              height: 20px;
              background: #af8653;
            }
          }
        }
      }
    }
  }

  .norem-right {
    flex: 1;
    margin-left: 40px;
  }
  .left {
    flex-basis: 234px;
    h1 {
      padding: 30px 20px;
      background: #ae8148;
      color: #fff;
      font-size: 28px;
    }
    ul {
      border: 1px solid rgba(215, 215, 215, 1);
      li {
        font-size: 20px;
        color: #000000;
        font-weight: 400;
        cursor: pointer;
        border-bottom: 1px solid rgba($color: #312f2e, $alpha: 0.1);
        display: flex;
        align-items: center;
        padding: 0 10px;
        .item {
          width: 100%;
          padding: 16px 0;
          &.no-child {
            &:hover {
              color: #af8653;
            }
          }
          .flex-box {
            align-items: center;
            justify-content: space-between;
          }
          img {
            width: 18px;
            height: 9px;
          }

          span {
            box-sizing: border-box;
            display: inline-block;
            padding: 16px 0;
            width: 100%;
            &.item-name {
              &:hover {
                color: #af8653;
              }
            }

            &.active {
              color: #af8653;
              &::before {
                display: inline-block;
                margin-right: 8px;
                content: '';
                position: relative;
                top: 3px;
                width: 2px;
                height: 20px;
                background: #af8653;
              }
            }
          }
          &.active {
            color: #af8653;
            &::before {
              display: inline-block;
              margin-right: 8px;
              content: '';
              position: relative;
              top: 3px;
              width: 2px;
              height: 20px;
              background: #af8653;
            }
          }
        }
      }
    }
  }

  .right {
    flex: 1;
    margin-left: 40px;
  }
}
</style>

